import React from 'react';
import LinkHash from 'components/LinkHash';
import { withRouter } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import NestedNavList from 'components/layout/MainAppBar/Nav/NestedNavList';

const SidebarNavList = ({ history, navItems, onNavClicked }) => {
  const onClickNav = route => {
    history.push(route);
    onNavClicked();
  };
  return (
    <List>
      {navItems.map(navItem =>
        navItem.subNavs ? (
          <NestedNavList key={navItem.text} navItem={navItem} onClickNav={route => onClickNav(route)} />
        ) : navItem.route.includes('#') ? (
          <ListItem button key={navItem.text}>
            <LinkHash route={navItem.route}>
              <ListItemText primary={navItem.text} primaryTypographyProps={{ variant: 'button' }} />
            </LinkHash>
          </ListItem>
        ) : (
          <ListItem key={navItem.text} button onClick={() => onClickNav(navItem.route)}>
            <ListItemText primary={navItem.text} primaryTypographyProps={{ variant: 'button' }} />
          </ListItem>
        )
      )}
    </List>
  );
};

export default withRouter(SidebarNavList);
